export default __webpack_public_path__ + "static/media/encircledWarning.951286d1.svg";